export const GET_CAMERA_CLASSES_SUCEEDED = "GET_CAMERA_CLASSES_SUCEEDED";
export const GET_CAMERA_CLASSES_REQUESTED = "GET_CAMERA_CLASSES_REQUESTED";
export const GET_CAMERA_CLASSES_FAILED = "GET_CAMERA_CLASSES_FAILED";
